// extracted by mini-css-extract-plugin
module.exports = {"forecastIcon":"ForecastIcon_forecastIcon__8_jkv"};